<template>
	<div id="about" class='page'>
		<div class="about-col">
            <div class="abracket" data-aos="fade-left" :data-aos-duration='1000'></div>
			<h1 data-aos="fade-in" :data-aos-duration=1000>
				 {{content.about_headline}}
			</h1>
			<p class='subline' data-aos="fade-in" :data-aos-duration='2000'>
				{{content.about_text[0].text}}
			</p>

			<!-- <router-link class='team_link' to="/team">{{content.zum_team}}</router-link> -->
		</div>
</div>
</template>

<script>

	export default {
		name: 'about',
		components: {

		},
		props: {
			content: Object,
		    langsufix: String,
		},
		data () {
			return {

				p: {}

			}
		},

		methods: {
			// getContent () {
			//   this.$prismic.client.getByUID('about','contact-'+this.langsufix)
			//     .then((document) => {
			//       console.log(document);
			//       this.p = document.data;
			//     })
			// },

		}
	}
</script>

<style lang="less" scoped>
@import '../less/variables.less';

#about {
	background-color: #FBFBFB;
	padding-top: 180px;
	padding-bottom: 180px;
	position: relative;

	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	background-image: url('/images/about_bg.jpg');
}

.team_link {
	text-align:left;
	.fmb(14px);
	text-decoration: none;
	&:visited {
		color: @g1;
	}
	// background-color: red;
	float: left;
}
.about-col {
	// display: inline-block;
    position: relative;
	vertical-align: top;
	text-align: left;
	width: 50%;
    // column-count: 2;
    margin-left: auto;
    margin-right: auto;
    padding: 50px 0px;
    .abracket {
        position: absolute;
        width: 400px;
        height: 100%;
        // background-color: yellow;
        right: -100px;
        margin-top: -40px;

            background-image: url('/images/bracket-black.svg');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center right;
    }
    p {
        position: relative;
                // min-height: 200px;
                // background-color: red;
                .fm(15px);
                vertical-align: top;
                margin-top: 0px;
                width: 100%;
                margin-top: 0px;
                color: @g1;
    }


	// &.right {
	// 	margin-left: 40px;
	// }

	h1 {
		.fmb(20px);
        position: relative;
		color: @g1;
		text-transform: uppercase;
        width: 100%;
        // background-color: green;
        margin-bottom: 0px;



	}

	// p {
	// 	.fm(12px);
	// 	color: rgba(0,0,0,0.6);
	// 	width: 50%;
	// 	min-width: 250px;
	// }
		// @media (max-width: @mobile_width) {
	 //        .fmb(46px);
	 //        line-height: 46px;
	 //        display: inherit;
	 //        width: 100%;
	 //        // padding-bottom: 100px;

	 //        p {
	 //        	width: 100%;

	 //        }
	 //    }
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.page-content {
	// top: -100px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

#login {
	// margin-top: 300px;
}
#input-set {

	.inputs {
		position: relative;
		margin-top: 30px;
	}
	.thanks {
		h2 {
			.fmb(20px);
		}

	}
	#checkboxs {
		display: inline-block;
		width: 100px;
		background-color: red;
	}
	a {
		color: @g1;
	}
	label {
		vertical-align: top;
		// background-color: green;
		height: 150px;
		color: @g1;
		clear: both;
		.fm(14px);
		margin-left: 5px;
		&.required {
			color: red;
		}

	}
	input[type="checkbox"]
	{
	    vertical-align:middle;
	    float: left;
	    .fm(14px);

	    border-color: red;
	    border: solid;
	    background-color: red;
	}


	input[type="text"], input[type="tel"], input[type="email"] {
		border: none;
		outline: none;
		text-align: left;
		border-bottom: solid;
		border-color: @c2;
		border-width: 1px;
		padding: 0px 0px;

		height: 50px;
		width: 100%;
		position: relative;
		.fm(14px);
		margin-bottom: 15px;
		color: @c2;
		background-color: transparent;

		&.required {
			border-color: red;
		}
	}
	textarea {
		border: none;
		outline: none;
		text-align: left;
		border: solid;
		border-color: @c2;
		border-width: 1px;
		padding: 10px 10px;
		height: 100px;
		width: 95%;
		position: relative;
		.fm(14px);
		margin-bottom: 15px;
		color: @c2;
		background-color: transparent;
		&.required {
			border-color: red;
		}
	}
	::placeholder {
		color: @c2;
		.fm(14px);
		text-transform: uppercase;
	}
	#add-button {
		// .br(2px);
		.fmb(12px);
		line-height: 40px;
		color: @c2;
		height: 40px;
		position: relative;
		text-align: left;
		left: 0px;
		// float: left;
		cursor: pointer;
		margin-top: 10px;
		background-color: @c3;
		display: table;
		text-transform: uppercase;
		padding-left: 20px;
		padding-right: 20px;
		border: solid;
		margin-top: 20px;
		// .login-icon {
		// 	position: absolute;
		// 	width: 50px;
		// 	height: 50px;
		// 	margin-left: 20px;
		// 	display: inline-block;
		// 	// background-image: url('/images/arrow-right.svg');
		// 	background-position: center center;
		// 	background-size: 60% auto;
		// 	background-repeat: no-repeat;
		// }
		&:hover {
			background-color: rgba(0,0,0,0.1);
		}
	}
}
</style>
